import {useMemo, useState} from "react";
import {ServiceEventTypeServiceTypeEntity} from "@ots-frontend/ots-data";
import {useDebouncedValue} from "@mantine/hooks";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";
import {getFormattedDatabaseCode} from "../../text/FormattedDatabaseCode/FormattedDatabaseCode";

export type UseServiceEventTypeServiceTypeDataTableFilterProps = Omit<UseDataTableFilterProps<ServiceEventTypeServiceTypeEntity>, 'filterConfig'>

export function useServiceEventTypeServiceTypeDataTableFilter(props: UseServiceEventTypeServiceTypeDataTableFilterProps): UseDataTableFilterResult<ServiceEventTypeServiceTypeEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [serviceEventTypeQuery, setServiceEventTypeQuery] = useState<string | undefined>(undefined);
  const [serviceEventTypeDebouncedQuery] = useDebouncedValue(serviceEventTypeQuery, 200);

  const filterConfig: DataTableFilterConfig<ServiceEventTypeServiceTypeEntity> = useMemo(() => {
    return {
      "serviceEventType": {
        setQuery: setServiceEventTypeQuery,
        query: serviceEventTypeQuery,
        debouncedQuery: serviceEventTypeDebouncedQuery,
        filter: ({serviceEventType}, query) => {
          if (serviceEventType) {
            const display = getFormattedDatabaseCode(serviceEventType, t)
            return !serviceEventType.code.toLowerCase().includes(query.toLowerCase()) && (!display || !display.toLowerCase().includes(query.toLowerCase()))
          } else {
            return false
          }
        }
      },
    }
  }, [
    serviceEventTypeQuery,
    serviceEventTypeDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
